import {createRandomStringGenerator} from '@better-auth/utils/random'
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

 type SqliteDataType = "integer" | "real" | "text" | "blob" | "numeric";


 export function mapToSqliteType(inputType: string): SqliteDataType {
    switch (inputType) {
      case "boolean":
      case "foreign_key":
        return "integer";
      case "date":
      case "datetime":
      case "json":
      case "array":
      case "varchar":
      case "text":
        return "text";
      case "real":
      case "numeric":
      case "blob":
      case "integer":
        return inputType as SqliteDataType;
      default:
        return "text";
    }
  }
export function sanitizeName(input: string): string {
  return input.replace(/[^a-zA-Z0-9_-]/g, "_");
}

export const generateRandomString = createRandomStringGenerator(
  "A-Z",
  "0-9",
  "a-z",
  "-_",
);



export function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return (
    Number.parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i]
  );
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}


